import apiClient from '../apiClient';
import { GET_DATA_TRANSFER_LOGS_BY_RANGE_URL } from '../apiUrl';

const getDataTransferLogsByRangeApi = (fromLine, toLine) => {
  return apiClient.get(GET_DATA_TRANSFER_LOGS_BY_RANGE_URL(fromLine, toLine));
};

export default getDataTransferLogsByRangeApi;
